import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from 'src/app/_config/config';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient, private config: CONFIG) { }

 gateway = this.config.gateway;
  saveFile(dataArgs , urlFileUpload ){
    let args: any;
    args = dataArgs;
    const url = urlFileUpload ; //"https://www.primefaces.org/primeng/showcase/upload.php";
    return this.http.post(`${url}`, args, {
      reportProgress: true,
      responseType: 'json'
    });
  }

}
